export const GerarDocumento = () => {
  return [
    { nomeDocumento: 'Atestado Psicológico', documento: 'gerar-documento-atestado-psicologico.html' },
    { nomeDocumento: 'Declaração', documento: 'gerar-documento-declaracao.html' },
    { nomeDocumento: 'Laudo', documento: 'gerar-documento-laudo.html' },
    { nomeDocumento: 'Parecer Psicológico', documento: 'gerar-documento-parecer-psicologico.html' },
    { nomeDocumento: 'Relatório Psicológico', documento: 'gerar-documento-relatorio-psicologico.html' },
  ];
};
